import { __spreadArray } from "tslib";
import * as React from 'react';
import { useMemo } from 'react';
var SIGNAL_TYPES;
(function (SIGNAL_TYPES) {
    SIGNAL_TYPES[SIGNAL_TYPES["SEND_CHAT_MESSAGE"] = 0] = "SEND_CHAT_MESSAGE";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_CHAT_MESSAGE"] = 1] = "RECEIVE_CHAT_MESSAGE";
    SIGNAL_TYPES[SIGNAL_TYPES["DELETE_CHAT_MESSAGE"] = 2] = "DELETE_CHAT_MESSAGE";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_DELETE_CHAT_MESSAGE"] = 3] = "RECEIVE_DELETE_CHAT_MESSAGE";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_PARTICIPANT"] = 4] = "RECEIVE_PARTICIPANT";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_PARTICIPANT_STATUS"] = 5] = "RECEIVE_PARTICIPANT_STATUS";
    SIGNAL_TYPES[SIGNAL_TYPES["SEND_REACTION"] = 6] = "SEND_REACTION";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_REACTION"] = 7] = "RECEIVE_REACTION";
    SIGNAL_TYPES[SIGNAL_TYPES["REQUEST_SOFT_MUTE"] = 8] = "REQUEST_SOFT_MUTE";
    SIGNAL_TYPES[SIGNAL_TYPES["SOFT_MUTE"] = 9] = "SOFT_MUTE";
    SIGNAL_TYPES[SIGNAL_TYPES["SCREENSHARE"] = 10] = "SCREENSHARE";
    SIGNAL_TYPES[SIGNAL_TYPES["JOIN_ERROR"] = 11] = "JOIN_ERROR";
    SIGNAL_TYPES[SIGNAL_TYPES["RECORDER_STOPPED"] = 12] = "RECORDER_STOPPED";
})(SIGNAL_TYPES || (SIGNAL_TYPES = {}));
export var JoinErrorType;
(function (JoinErrorType) {
    JoinErrorType[JoinErrorType["TIMEOUT"] = 0] = "TIMEOUT";
    JoinErrorType[JoinErrorType["FAILED"] = 1] = "FAILED";
})(JoinErrorType || (JoinErrorType = {}));
var api = function () {
    var callbacks = {};
    var send = function (type) {
        var payload = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            payload[_i - 1] = arguments[_i];
        }
        var callbackArray = callbacks[type] || [];
        callbackArray.forEach(function (callback) { return callback.apply(void 0, payload); });
    };
    var receive = function (type, callback) {
        callbacks[type] = callbacks[type] || [];
        callbacks[type].push(callback);
        return function () {
            var callbackIndex = callbacks[type].indexOf(callback);
            callbacks[type] = __spreadArray(__spreadArray([], callbacks[type].slice(0, callbackIndex), true), callbacks[type].slice(callbackIndex + 1), true);
        };
    };
    return {
        sendChatMessage: function (message) { return send(SIGNAL_TYPES.SEND_CHAT_MESSAGE, message); },
        onSendChatMessage: function (callback) { return receive(SIGNAL_TYPES.SEND_CHAT_MESSAGE, callback); },
        receiveChatMessage: function (message) { return send(SIGNAL_TYPES.RECEIVE_CHAT_MESSAGE, message); },
        onReceiveChatMessage: function (callback) {
            return receive(SIGNAL_TYPES.RECEIVE_CHAT_MESSAGE, callback);
        },
        deleteChatMessage: function (id) { return send(SIGNAL_TYPES.DELETE_CHAT_MESSAGE, id); },
        onDeleteChatMessage: function (callback) { return receive(SIGNAL_TYPES.DELETE_CHAT_MESSAGE, callback); },
        receiveDeleteChatMessage: function (id) { return send(SIGNAL_TYPES.RECEIVE_DELETE_CHAT_MESSAGE, id); },
        onReceiveDeleteChatMessage: function (callback) {
            return receive(SIGNAL_TYPES.RECEIVE_DELETE_CHAT_MESSAGE, callback);
        },
        recorderStopped: function (recording) { return send(SIGNAL_TYPES.RECORDER_STOPPED, recording); },
        onRecorderStopped: function (callback) {
            return receive(SIGNAL_TYPES.RECORDER_STOPPED, callback);
        },
        receiveParticipant: function (receivedParticipant) {
            return send(SIGNAL_TYPES.RECEIVE_PARTICIPANT, receivedParticipant);
        },
        onReceiveParticipant: function (callback) {
            return receive(SIGNAL_TYPES.RECEIVE_PARTICIPANT, callback);
        },
        receiveParticipantStatus: function (receivedParticipantStatus) {
            return send(SIGNAL_TYPES.RECEIVE_PARTICIPANT_STATUS, receivedParticipantStatus);
        },
        onReceiveParticipantStatus: function (callback) {
            return receive(SIGNAL_TYPES.RECEIVE_PARTICIPANT_STATUS, callback);
        },
        sendReaction: function (reaction) { return send(SIGNAL_TYPES.SEND_REACTION, reaction); },
        onSendReaction: function (callback) { return receive(SIGNAL_TYPES.SEND_REACTION, callback); },
        receiveReaction: function (reaction) { return send(SIGNAL_TYPES.RECEIVE_REACTION, reaction); },
        onReceiveReaction: function (callback) { return receive(SIGNAL_TYPES.RECEIVE_REACTION, callback); },
        requestSoftMute: function (participantId) { return send(SIGNAL_TYPES.REQUEST_SOFT_MUTE, { participantId: participantId }); },
        onRequestSoftMute: function (callback) {
            return receive(SIGNAL_TYPES.REQUEST_SOFT_MUTE, callback);
        },
        softMute: function (payload) { return send(SIGNAL_TYPES.SOFT_MUTE, payload); },
        onSoftMute: function (callback) { return receive(SIGNAL_TYPES.SOFT_MUTE, callback); },
        toggleScreenshare: function (enabled) { return send(SIGNAL_TYPES.SCREENSHARE, enabled); },
        onToggleScreenshare: function (callback) { return receive(SIGNAL_TYPES.SCREENSHARE, callback); },
        joinError: function (error) { return send(SIGNAL_TYPES.JOIN_ERROR, error); },
        onJoinError: function (callback) { return receive(SIGNAL_TYPES.JOIN_ERROR, callback); },
    };
};
export var SignalingApiProvider = function (_a) {
    var children = _a.children;
    var signalingApi = useMemo(api, []);
    return React.createElement(SignalingApiContext.Provider, { value: signalingApi }, children);
};
var SignalingApiContext = React.createContext(null);
export var useSignalingApi = function () { return React.useContext(SignalingApiContext); };
//# sourceMappingURL=signaling-api.js.map